export default "__VITE_ASSET__c048bf9a__"